const slides = '[{"id":"1","title":"Cone","url":"https:\\/\\/admin-cone.coneconsultoria.com.br\\/wp-content\\/uploads\\/2020\\/11\\/slide-1.jpg","description":"Consultoria e Excel\\u00eancia a mais de 30 anos.","position":"1","style":"","created":"2020-11-15 18:57:15","modified":"2020-11-24 23:41:46"}]';

export default JSON.parse(slides);
